"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const functional_1 = require("./functional");
const templateRe = /\$\{([\w.]*)\}/g;
const templateReSingle = /\$\{[\w.]*\}/;
const throwError = str => {
    const error = new Error(`Config missing for ${str}`);
    throw error;
};
const objectAccess = (obj, keys, str) => (0, functional_1.pipe)(keys)((0, functional_1.reduce)((acc, key) => (acc[key] ? acc[key] : throwError(str)), obj));
const interpolateString = (str, config) => {
    const replacementKeys = (0, functional_1.pipe)(str.match(templateRe) || [])((0, functional_1.map)(s => s.replace(/[${}]/g, '')), (0, functional_1.map)(s => s.split('.')));
    return (0, functional_1.pipe)(replacementKeys)((0, functional_1.reduce)((acc, keys) => acc.replace(templateReSingle, objectAccess(config, keys, str)), str));
};
exports.default = interpolateString;
//# sourceMappingURL=interpolate-string.js.map